import React, { useEffect, useContext, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { auth } from './utils/firebase';
import { onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import { SettingsContext } from './contexts/settings-provider';

import Join from './pages/Join/Join';
import Play from './pages/Play/Play';
import Display from './pages/Display/Display';
import Loading from './components/Loading/Loading';

function App() {
  const [loading, setLoading] = useState(true);
  const [, dispatch] = useContext(SettingsContext);

  useEffect(() => {
    signInAnonymously(auth)
      .then(() => {})
      .catch((error) => {
        const errorMessage = error.message;
        console.log(errorMessage);
      });
  }, []);

  useEffect(() => {
    const unsubsrcibe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setLoading(false);
        dispatch({ type: 'update_user', payload: user });
      }
    });
    return () => {
      unsubsrcibe();
    };
  }, [dispatch]);

  if (loading) {
    return <Loading />;
  } else {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Join />} />
          <Route path="host" element={<Display />} />
          <Route path="play" element={<Play />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
